import { render, staticRenderFns } from "./AssetAssignmentModal.vue?vue&type=template&id=b353d45e&scoped=true&"
import script from "./AssetAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./AssetAssignmentModal.vue?vue&type=script&lang=js&"
import style0 from "./AssetAssignmentModal.vue?vue&type=style&index=0&id=b353d45e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b353d45e",
  null
  
)

export default component.exports